/** Google Sign-In (Emergent-managed). Identity only — the backend decides CRM vs candidate portal. */
import React, { useEffect, useRef, useState } from 'react';
import { useLocation } from 'react-router-dom';
import api from '../../lib/api';

export function GoogleSignInButton({ label = 'Continue with Google' }) {
  const go = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + '/dashboard';
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };
  return (
    <button type="button" onClick={go} className="flex h-11 w-full items-center justify-center gap-2 rounded-md border bg-white text-sm font-medium text-slate-800 transition-colors hover:bg-slate-50" data-testid="google-signin-btn">
      <span className="text-base font-bold text-[#4285F4]">G</span>{label}
    </button>
  );
}

function GoogleCallback() {
  const location = useLocation();
  const done = useRef(false);
  const [error, setError] = useState('');
  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const sessionId = new URLSearchParams(location.hash.slice(1)).get('session_id');
    api.request('/auth/google/session', { method: 'POST', body: JSON.stringify({ session_id: sessionId, invite_token: localStorage.getItem('pending_invite_token') || undefined }) })
      .then((r) => {
        localStorage.setItem('token', r.access_token);
        localStorage.setItem('refresh_token', r.refresh_token);
        localStorage.removeItem('pending_invite_token');
        window.history.replaceState(null, '', window.location.pathname);
        window.location.replace(r.route || '/');
      })
      .catch((e) => setError(typeof e.message === 'string' ? e.message : 'Google sign-in failed'));
  }, [location.hash]);
  if (!error) return null;
  return <div className="p-10 text-center text-sm" data-testid="google-signin-error">{error} — <a className="underline" href="/login">back to sign in</a></div>;
}

export function GoogleHashGate({ children }) {
  const location = useLocation();
  if (location.hash?.includes('session_id=')) return <GoogleCallback />;
  return children;
}
